import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import {
  FaLinkedin,
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaTimesCircle,
} from "react-icons/fa";
import { RxExternalLink } from "react-icons/rx";
import "./styles/ArticleDetail.css";
import { MdGppGood } from "react-icons/md";
import { FcReadingEbook } from "react-icons/fc";
import { MdTimer } from "react-icons/md";
import { IoPlayBack } from "react-icons/io5";

const ArticleDetail = () => {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [recommendedArticles, setRecommendedArticles] = useState([]);
  useEffect(() => {
    const API_URL = process.env.REACT_APP_URL_CORS; // URL de l'API

    fetch(`${API_URL}/api/articles/${id}`)
      .then((response) => {
        if (!response.ok) throw new Error("Article non trouvé");
        return response.json();
      })
      .then((data) => {
        setArticle(data);
        setRecommendedArticles(data.recommandations || []);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [id]);

  if (loading)
    return (
      <h2 className="text-center mt-5">
        {" "}
        <MdTimer className="MdTimer" /> Chargement...
      </h2>
    );
  if (error)
    return (
      <h2 className="text-center mt-5">
        {" "}
        <FaTimesCircle className="FaTimesCircle" /> {error}
      </h2>
    );

  return (
    <div className="article-container">
      <div className="article-layout">
        {/* Colonne de gauche - Liens utiles */}
        <aside className="article-sidebar left">
          <h4 style={{ color: "#ff7e5f" }}> Useful links</h4>
          {article.links && article.links.length > 0 ? (
            article.links.map((section, index) => (
              <ul key={index}>
                <li >
                  <a
                    href={section.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <RxExternalLink /> {section.text}
                  </a>
                </li>
              </ul>
            ))
          ) : (
            <p>No link available.</p>
          )}
        </aside>

        {/*  Contenu principal */}
        <main className="article-content">
          <h1 className="article-title">{article.title}</h1>
          <div className="article-meta">
            <span> {article.date} </span> |<MdTimer className="MdTimer" />{" "}
            <span>{article.time}</span> |{" "}
            <span>{article.author || "Inconnu"}</span>
          </div>
          <img
            src={`/${article.image}`}
            alt={article.title}
            className="article-image"
          />
          <div className="article-body">
            {article.content.map((section, index) => {
              if (section.type === "paragraph")
                return <p key={index}>{section.text}</p>;
              if (section.type === "heading")
                return (
                  <h4 key={index} className="article-heading">
                    {section.text}
                  </h4>
                );
           
              if (section.type === "img")
                return (
                  <img
                    key={index}
                    className="section-image"
                    src={`/${section.src}`}
                    alt="Illustration"
                  />
                );
              if (section.type === "heading2")
                return (
                  <h5 key={index} className="article-heading2">
                    {section.text}
                  </h5>
                );
              if (section.type === "list")
                return (
                  <ul key={index}>
                    {section.items.map((item, i) => (
                      <p key={i}>
                        <MdGppGood className="MdGppGood3" />
                        {item}
                      </p>
                    ))}
                  </ul>
                );
              return null;
            })}
          </div>
        </main>

        {/* 📌 Colonne de droite - Articles recommandés & Partage */}
        <aside className="article-sidebar right">
          <h4 style={{ color: "#ff7e5f" }}>
            {" "}
            <FcReadingEbook /> Recommended items
          </h4>
          {recommendedArticles.length > 0 ? (
            <ul className="reading-plan">
              {recommendedArticles.map((recommended, index) => (
                <li key={index} className="reading-item">
                  <Link
                    to={`/article/${recommended.id}`}
                    className="reading-link"
                  >
                    <RxExternalLink /> {recommended.title}
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <p>No recommended items available.</p>
          )}

          {/*  Partage sur les réseaux sociaux */}
          <div className="social-share">
            <h5> Share this article</h5>
            <div className="social-icons">
              {(() => {
                const articleUrl = encodeURIComponent(window.location.href);
                const articleTitle = encodeURIComponent(article.title);

                return (
                  <>
                    <a
                      href={`https://www.linkedin.com/sharing/share-offsite/?url=${articleUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLinkedin className="social-icon linkedin" />
                    </a>
                    <a
                      href={`https://www.facebook.com/sharer/sharer.php?u=${articleUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon facebook" />
                    </a>
                    <a
                      href={`https://twitter.com/intent/tweet?url=${articleUrl}&text=${articleTitle}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaTwitter className="social-icon twitter" />
                    </a>
                    <a
                      href={`https://www.instagram.com/`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon instagram" />
                    </a>
                  </>
                );
              })()}
            </div>
          </div>
        </aside>
      </div>

      <div className="back-button">
        <Link to="/" className="btn btn-secondary">
          <IoPlayBack className="IoPlayBack" /> Back to articles
        </Link>
      </div>
    </div>
  );
};

export default ArticleDetail;
